import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Clock } from 'lucide-react';
import { contactInfo } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#232323] text-white py-16">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-semibold mb-2">
              Senior's Desk
            </h3>
            <p className="text-sm text-gray-400 font-mono uppercase tracking-wide mb-4">
              Concierge Support for Senior Living
            </p>
            <p className="text-gray-300 text-sm leading-relaxed max-w-md">
              Personal, human assistance for senior citizens and their families. 
              No apps, no subscriptions — just caring support when you need it.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-gray-400">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/how-it-works" className="text-gray-300 hover:text-white transition-colors text-sm">
                How It Works
              </Link>
              <Link to="/services" className="text-gray-300 hover:text-white transition-colors text-sm">
                Our Services
              </Link>
              <Link to="/pricing" className="text-gray-300 hover:text-white transition-colors text-sm">
                Pricing
              </Link>
              <Link to="/request-help" className="text-gray-300 hover:text-white transition-colors text-sm">
                Request Help
              </Link>
              <Link to="/contact" className="text-gray-300 hover:text-white transition-colors text-sm">
                Contact Us
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-gray-400">
              Contact Us
            </h4>
            <div className="flex flex-col gap-4">
              <a 
                href={`mailto:${contactInfo.email}`}
                className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors text-sm"
              >
                <Mail className="w-4 h-4" />
                {contactInfo.email}
              </a>
              <a 
                href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
                className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors text-sm"
              >
                <Phone className="w-4 h-4" />
                {contactInfo.phone}
              </a>
              <div className="flex items-center gap-3 text-gray-300 text-sm">
                <Clock className="w-4 h-4" />
                {contactInfo.hours}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Senior's Desk. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm">
              Made with care for seniors and their families.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;